import classNames from 'classnames';
import { FC } from 'react';
import { Link } from 'react-router-dom';

import {
  IMainCatalogChild,
  IMainCatalogItem,
} from '../../shared/types/main-catalog';

interface ICatalogItem {
  setOpenCategory: (name: 'processes' | 'materials' | 'equipments') => void;
  item: any;
  openCategory: string;
  onMouseCatalogItem: (obj: IMainCatalogItem) => void;
  tooltipIsOpen: IMainCatalogChild;
  handleClose: () => void;
}
// Элемент каталога
const CatalogItem: FC<ICatalogItem> = ({
  setOpenCategory,
  item,
  openCategory,
  onMouseCatalogItem,
  tooltipIsOpen,
  handleClose,
}) => {
  const textTopMenu =
    item[0] === 'processes'
      ? 'Процессы'
      : item[0] === 'materials'
      ? 'Материалы'
      : 'Оборудование';
  return (
    <>
      <li
        onMouseMove={() => setOpenCategory(item[0])}
        className="catalog-menu-top__list"
      >
        <p
          onMouseMove={() => onMouseCatalogItem(item[1][0])}
          className={
            openCategory === item[0]
              ? 'catalog-menu-top__text active'
              : 'catalog-menu-top__text'
          }
        >
          {textTopMenu}
        </p>
      </li>
      {openCategory === item[0] && (
        <div className="catalog-menu-top__wrapper">
          {item &&
            item[1]?.map((process: any) => {
              return (
                <Link
                  to={`/${
                    openCategory === 'equipments' ? 'equipment' : openCategory
                  }/${process.slug}`}
                >
                  <div
                    key={process.id}
                    onMouseMove={() => onMouseCatalogItem(process)}
                    className="catalog-menu__block"
                  >
                    <li
                      onClick={handleClose}
                      className={classNames('catalog-menu__title', {
                        active: process.id === tooltipIsOpen.id,
                      })}
                    >
                      {process?.title}
                    </li>
                  </div>
                </Link>
              );
            })}
        </div>
      )}
    </>
  );
};

export default CatalogItem;
